import type { FetchPolicy } from 'apollo-client';

import { HomeHeaderImageQuery, HomeProfileQuery } from './HomeNavigationQueries';

export const getHomeProfileQueryOptions = ({
	isLoggedIn,
	skip,
}: {
	isLoggedIn: boolean;
	skip: boolean;
}) => ({
	query: HomeProfileQuery,
	skip: !isLoggedIn || skip,
});

export const getHomeHeaderImageQueryOptions = ({
	isLoggedIn,
	userId,
	cloudId,
	fetchPolicy = 'cache-and-network' as FetchPolicy,
	skip,
}: {
	isLoggedIn: boolean;
	userId: string | null;
	cloudId: string;
	fetchPolicy?: FetchPolicy;
	skip: boolean;
}) => ({
	query: HomeHeaderImageQuery,
	skip: !isLoggedIn || Boolean(process.env.REACT_SSR) || skip,
	variables: {
		userId: userId || '',
		cloudId,
	},
	fetchPolicy,
});
